<template>
  <page-content>

    <panel ref="searchFormPanel" show-close show-collapse title="Thông tin tìm kiếm">
      <c-form ref="searchForm" @submit="search()">


        <b-row>
          <c-input label="Request body" form-group-class="col-md-4 col-sm-6" v-model.trim="searchForm.requestBody"/>
          <c-select2 v-model="searchForm.status" form-group-class="col-md-4 col-sm-6" label="Trạng thái">
            <option value="FAILURE">Không thành công</option>
            <option value="SUCCESS">Thành công</option>
          </c-select2>
          <c-select2 v-model="searchForm.type" form-group-class="col-md-4 col-sm-6" label="Loại lỗi">
            <option value="PACKAGE_REQUEST">Đăng đơn</option>
            <option value="CREATE_BILL_OUTPUT">Tạo phiếu xuất</option>
            <option value="CONFIRM_BILL">Xác nhận phiếu</option>
            <option value="CANCEL_PACKAGE">Hủy đơn</option>
            <option value="PACKAGE_CHECK_PRODUCT">Check sản phẩm trong đơn</option>
          </c-select2>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>
            <button class="btn btn-secondary" type="reset" @click="resetFormSearch()">
              <i class="fas fa-redo-alt"></i>
              Xóa bộ lọc
            </button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel ref="panel" show-collapse title="Danh sách lỗi">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="$refs.searchFormPanel.open()">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="searchForm"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Trạng thái', width: '100px', sortField:'status', sortable: true},
                   {text: 'Loại lỗi', width: '150px', sortField:'type', sortable: true},
                   {text: 'Retry', width: '50px', sortField:'retryNumber', sortable: true},
                   {text: 'Lý do lỗi', sortField:'errorMessage'},
                   {text: 'Request body', sortField:'requestBody'},
                   {text: 'Created At', width: '100px', sortField:'createdAt'},
                   {text: 'Updated At', width: '100px', sortField:'updatedAt'},
                   {text: 'Thao tác', width: '150px'},
               ]"
               uri="/cms/api/v1.0/error-request/get-all"
      >
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td class="text-center">
            <i v-if="item.status === 'SUCCESS'" class="fas fa-check-circle green fa-2x"></i>
            <i v-else class="fad fa-spider-black-widow red fa-2x"></i>
          </td>
          <td>{{ item.type }}</td>
          <td>{{ item.retryNumber }}</td>
          <td>{{ item.errorMessage }}</td>
          <td>
            <vue-json-pretty :data="JSON.parse(item.requestBody)" show-length show-line :deep="0"/>
          </td>
          <td>{{ item.createdAt | datetime }}</td>
          <td>{{ item.updatedAt | datetime }}</td>
          <td class="text-center">
            <b-button v-b-tooltip.hover.left
                      class="btn btn-icon"
                      title="Xử lý lại"
                      type="button"
                      variant="success"
                      @click="retry(item)">
              <i class="fas fa-sync-alt"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>

  </page-content>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
  name: "Index",
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      searchForm: {
        status: 'FAILURE',
        requestBody: null,
        type: null
      }
    }
  },
  mounted() {
  },
  methods: {
    search() {
      this.$refs.table.reload();
    },
    resetFormSearch() {
      this.searchForm.shopCode = null;
      this.searchForm.shopName = null;
      this.searchForm.name = null;
      this.search();
    },
    retry(item) {
      this.$warning('Chức năng đang phát triển!');
    }
  }
}
</script>

<style scoped>

</style>